export const booleanToString = (string) => {
  if (string === true) return 'true';
  if (string === false) return 'false';
};

export const stringToBoolean = (string) => {
  if (string === 'true') return true;
  if (string === 'false') return false;
};
